import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthRepository } from '../repositories/auth.repository';
import { AuthTokens, LoginRequest } from '../models';

/**
 * Use case para realizar login
 * Baseado no realizar_login_usecase.dart do Flutter
 */
@Injectable({
  providedIn: 'root'
})
export class RealizarLoginUseCase {
  constructor(private authRepository: AuthRepository) {}

  /**
   * Executa o processo de login
   * @param request - Parâmetros do login (opcional)
   * @returns Observable<AuthTokens> - Tokens de autenticação
   */
  execute(request?: LoginRequest): Observable<AuthTokens> {
    const defaultRequest: LoginRequest = {
      scopes: ['openid', 'profile', 'email', 'offline_access'],
      prompt: 'select_account',
      ...request
    };

    return this.authRepository.login(defaultRequest);
  }
}
